import { IconProps } from '../';

const defaultSize = 48;

export const WarningIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      height={sizeToUse}
      width={sizeToUse}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.33337 28.6667H30.6667L16 3.33333L1.33337 28.6667ZM17.3334 24.6667H14.6667V22H17.3334V24.6667ZM17.3334 19.3333H14.6667V14H17.3334V19.3333Z"
        fill="#FFD801"
      />
      <path
        d="M1.33337 28.6667H30.6667L16 3.33333L1.33337 28.6667ZM17.3334 24.6667H14.6667V22H17.3334V24.6667ZM17.3334 19.3333H14.6667V14H17.3334V19.3333Z"
        fill="black"
        fill-opacity="0.1"
      />
    </svg>
  );
};
